// scopedStore.ts
import { createStore, StoreApi } from 'zustand';
import { createZustandVisualUnitSlice, zustand_VisualUnitSlice } from './VisualUnits/zustandVisualUnitSlice';

export type VisualUnitStore = StoreApi<zustand_VisualUnitSlice>;

export const createZustandScopedVisualUnitStore = (): VisualUnitStore =>
  createStore<zustand_VisualUnitSlice>(createZustandVisualUnitSlice);